import React, { useState, useEffect } from "react";
import ApiService from "../../services/Api.service";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Alert from "../Alert/Alert";
import Pagination from "../Pagination/Pagination";
import StatusBadge from "../../utilities/StatusBadge";
import FilterBar from "../FilterBar/FilterBar";
import Loader from "../Loader/Loader";
import AuthService from "../../services/Auth.service";
import { Trash2, KeyRound, Edit2, Edit, Ban, CircleCheckBig } from "lucide-react";
import ConfirmDeleteModal from "../ModelUI/ConfirmDeleteModal/ConfirmDeleteModal";
import CompanyEditModel from "./CompanyEditModal";
export default function CompanyList() {
    const [Loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [postsPerPage, setPostsPerPage] = useState(20);
    const [headers, setHeaders] = useState([]);
    const [dropDownData, setDropDownData] = useState([]);
    const [roleDropdown, setRoleDropdown] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [showResetModal, setShowResetModal] = useState(false);
    const [resetTarget, setResetTarget] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editTarget, setEditTarget] = useState(null);
    const [showAddModal, setShowAddModal] = React.useState(false);

    const handleAddClick = () => {
        setShowAddModal(true);
    };

    const [pagination, setPagination] = useState({
        page: 1,
        size: 20,
        total: 0,
        total_pages: 0,
    });
    const [alertValue, setAlertValue] = useState({
        show: false,
        message: "",
        variant: "success",
        position: "middle",
    });
    const [selectedRowIndex, setSelectedRowIndex] = useState(null);

    const validationSchema = yup.object().shape({
    });

    const {
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validationSchema),
    });
    const fetchDetail = async (page = 1, size = postsPerPage, payload = null) => {
        try {
            setLoading(true);
            if (!payload) {
                payload = {
                    subprocess_id: "",
                    duration: "All",
                    status: "All",
                    disposition: "All",
                };
            }
            const res = await AuthService.getCompanyList(payload, { page, size });
            if (res.status === 200 && res.data) {
                setTableData(res.data.data);
                setPagination(res.data.pagination);
                setHeaders(res.data.header);
                setSelectedRowIndex(null);
                setLoading(false);
            }
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

    const fetchDropdownDetail = async () => {
        try {
            const subprocessRes = await ApiService.getSubprocesses();
            if (subprocessRes.status === 200) setDropDownData(subprocessRes.data);

            const userRoleRes = await AuthService.getUserRoles();
            if (userRoleRes.status === 200 && userRoleRes.data.user_roles)
                setRoleDropdown(userRoleRes.data.user_roles);


        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchDropdownDetail();
        fetchDetail();
    }, []);

    const handelSubmit = async (data) => {

        fetchDetail(1, postsPerPage, data);
    };


    const handleClearFilters = () => {
        reset({
            companyCode: "",
            duration: "",
            status: "All",
            disposition: "All",
        });
        fetchDetail();
    };

    const handlePageSizeChange = (e) => {
        const newSize = Number(e.target.value);
        setPostsPerPage(newSize);
        fetchDetail(1, newSize);
        setSelectedRowIndex(null);
    };

    const mistableTh = {
        backgroundColor: "transparent",
        color: "rgba(43, 58, 103, 1)",
        fontFamily: "Nunito",
        fontSize: "12px",
        fontWeight: 700,
        lineHeight: "16px",
        letterSpacing: "0.1em",
        textAlign: "center",
    };

    const tableTdStyles = {
        fontFamily: "Nunito",
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "16px",
        letterSpacing: "0em",
        textAlign: "center",
        color: "#232122",
    };

    const handleDeleteUser = async () => {
        if (!deleteTarget) return;
        try {
            const res = await AuthService.deleteAgent(deleteTarget.id);
            if (res.status === 200) {
                setAlertValue({
                    show: true,
                    message: `${deleteTarget.name || "User"} deleted successfully!`,
                    variant: "success",
                    position: "middle",
                });
                fetchDetail(pagination.page, postsPerPage); // refresh
            }
        } catch (error) {
            console.error(error);
            setAlertValue({
                show: true,
                message: error.response?.data?.detail,
                variant: "danger",
                position: "middle",
            });
        } finally {
            setShowDeleteModal(false);
            setDeleteTarget(null);
        }
    };

    const handleUpdateUserDetails = async (data) => {
        try {
            let res;
            if (data.id) {
                // Edit mode
                res = await AuthService.updateCompany(data.id, data);
            } else {
                // Add mode
                res = await AuthService.addNewCompany(data);
            }

            if (res.status === 200) {
                setAlertValue({
                    show: true,
                    message: data.id ? "company updated successfully!" : "company added successfully!",
                    variant: "success",
                    position: "middle",
                });
                fetchDetail(pagination.page, postsPerPage); // refresh table
            }
        } catch (error) {
            setAlertValue({
                show: true,
                message: error.response?.data?.detail || "Something went wrong!",
                variant: "danger",
                position: "middle",
            });
        }
    };



    return (
        <> {alertValue.show && (
            <Alert
                variant={alertValue.variant}
                message={alertValue.message}
                dismissible={true}
                timeout={2500}
                position={alertValue.position}
                onClose={() => setAlertValue({ show: false, message: "", variant: "" })}
            />
        )}
                <>
                    {Loading && (
                        <div className="loader-container">
                            <Loader />
                        </div>
                    )}

                    <div className="main-contanier">
                        <FilterBar
                            control={control}
                            handleSubmit={handleSubmit}
                            onSubmit={handelSubmit}
                            onClearFilters={handleClearFilters}
                            filters={[]}
                            title={"Companies"}
                            totalCount={pagination.total || 0}
                            tableId="table-id"
                            isDownload={false}
                            isAdd={true}
                            onAdd={handleAddClick}
                        />

                        <div className="table-container dailymis-table" style={{ height: "400px" }}>
                            <table id="table-id" className="custom-table-container">
                                <thead
                                    className="table-head"
                                    style={{ position: "sticky", top: "0", zIndex: "1" }}
                                >

                                    <tr>
                                        <th style={mistableTh}>S.No</th>
                                        {headers.map((header, i) => (
                                            <th key={i} style={mistableTh}>
                                                {header.label}
                                            </th>
                                        ))}
                                        <th style={mistableTh}>Actions</th>
                                    </tr>


                                </thead>

                                <tbody>
                                    {tableData.length > 0 ? (
                                        tableData.map((item, index) => (
                                            <tr key={index} style={{ cursor: "pointer" }}>
                                                <td
                                                    style={{
                                                        ...tableTdStyles,
                                                        backgroundColor:
                                                            selectedRowIndex === index ? "#f9faff" : "transparent",
                                                    }}
                                                >
                                                    {(pagination.page - 1) * pagination.size + index + 1}
                                                </td>
                                                {headers.map((header, i) => (
                                                    <td
                                                        key={i}
                                                        style={{
                                                            ...tableTdStyles,
                                                            backgroundColor:
                                                                selectedRowIndex === index ? "#f9faff" : "transparent",
                                                        }}
                                                    >
                                                        {header.value === "status" ?(
                                                            item[header.value] ==true ? "Active": "Inactive"

                                                        ): (item[header.value] ?? "--")}
                                                    </td>
                                                ))}
                                                <td style={tableTdStyles} >
                                                    <button
                                                        className="icon-btn reset-btn"
                                                        onClick={() => {
                                                            setEditTarget(item);
                                                            setShowEditModal(true);
                                                        }}
                                                        title="Update Company"
                                                        style={{ marginLeft: "8px" }}
                                                    >
                                                        <Edit size={18} color="#f4a261" />
                                                    </button>
                                                </td>

                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan={
                                                    headers.length + 1
                                                }
                                                style={tableTdStyles}
                                            >
                                                No data available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <Pagination
                            pagination={pagination}
                            postsPerPage={postsPerPage}
                            handlePageSizeChange={handlePageSizeChange}
                            fetchDetail={fetchDetail}
                        />
                    </div>
                </>
            {showDeleteModal && (
                <ConfirmDeleteModal
                    onClose={() => {
                        setShowDeleteModal(false);
                        setDeleteTarget(null);
                    }}
                    onConfirm={handleDeleteUser}
                    itemName={deleteTarget?.name || "this user"}
                />
            )}
            {showEditModal && (
                <CompanyEditModel
                    initialData={editTarget}
                    onClose={() => {
                        setShowEditModal(false);
                        setEditTarget(null);
                    }}
                    onSave={handleUpdateUserDetails}
                />
            )}

            {showAddModal && (
                <CompanyEditModel
                    onClose={() => setShowAddModal(false)}
                    onSave={handleUpdateUserDetails} // same function for add/edit
                />
            )}

        </>

    );
}

